import { createClient } from "@supabase/supabase-js";

// Deliberately namespaced REACT_APP_BOOKS_* (not REACT_APP_SUPABASE_*) so
// this can sit alongside multi-iq's own Supabase project/client without
// colliding once merged — two separate projects, two separate env var
// pairs, both fine in the same app.
const supabaseUrl = process.env.REACT_APP_BOOKS_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_BOOKS_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  console.warn(
    "Books Supabase env vars missing. Add REACT_APP_BOOKS_SUPABASE_URL and REACT_APP_BOOKS_SUPABASE_ANON_KEY to .env."
  );
}

// Anon key only — there is no server here to hold a service-role key.
// Every write (admin book edits, lead inserts) relies on the RLS policies
// in sql/schema.sql (same schema as the Next.js version) rather than a
// service-role bypass.
export const supabase =
  supabaseUrl && supabaseAnonKey
    ? createClient(supabaseUrl, supabaseAnonKey)
    : null;

export const isSupabaseConfigured = () => !!supabase;
